import { MutationTree } from 'vuex'
import { State } from '@/store/index'
import Account from '@/api/models/Account'
import Brand from '@/api/models/Brand'
import Campaign from '@/api/models/Campaign'
import Reference from '@/api/models/Reference'
import Vue from 'vue'
import Settings from '@/api/models/Settings'
import References from '@/api/models/References'
import WarehousesMapping from '@/api/models/WarehousesMapping'
import OrderStatusesDto from '@/api/dto/OrderStatusesDto'
import ReturnStatusesDto from '@/api/dto/ReturnStatusesDto'
import PaymentTypesDto from '@/api/dto/PaymentTypesDto'
import CampaignReferences from '@/api/models/CampaignReferences'
import SettingsMapping from '@/api/models/SettingsMapping'
import CatalogManagementDto from '@/api/dto/CatalogManagementDto'

export enum RootStateMutations {
    setLoading = 'setLoading',
    setBrand = 'setBrand',
    setSites = 'setSites',
    setAccount = 'setAccount',
    setAccounts = 'setAccounts',
    updateAccount = 'updateAccount',
    createAccount = 'createAccount',
    setCampaign = 'setCampaign',
    setCampaigns = 'setCampaigns',
    updateCampaign = 'updateCampaign',
    addCampaign = 'addCampaign',
    deleteCampaign = 'deleteCampaign',
    setSettings = 'setSettings',
    setReferences = 'setReferences',
    setCampaignReferences = 'setCampaignReferences',
    setCampaignReferencesNotLoad = 'setCampaignReferencesNotLoad',
    setPriceLink = 'setPriceLink',
    setOrderStatuses = 'setOrderStatuses',
    setReturnOrderStatuses = 'setReturnOrderStatuses',
    setPaymentTypes = 'setPaymentTypes',
    setWarehousesMapping = 'setWarehousesMapping',
    setCosts = 'setCosts',
    setCatalogMapping = 'setCatalogMapping',
    setNotificationKey = 'setNotificationKey'
}

export const mutations: MutationTree<State> = {
    [RootStateMutations.setLoading] (state: State, isLoading: boolean) {
        state.loading = isLoading
    },
    [RootStateMutations.setBrand] (state: State, brand: Brand) {
        state.brand = brand
    },
    [RootStateMutations.setSites] (state: State, sites: Array<Reference>) {
        state.sites = sites
    },
    [RootStateMutations.setAccount] (state: State, account: number) {
        state.currentAccount = account
    },
    [RootStateMutations.setAccounts] (state: State, accounts: Array<Account>) {
        state.accounts = accounts
    },
    [RootStateMutations.updateAccount] (state: State, account: Account) {
        const index = state.accounts.findIndex(value => {
            return value.id === account.id
        })
        // меняем только поле name
        const updatedAccount = state.accounts[index]
        updatedAccount.name = account.name
        updatedAccount.apiKeyToken = account.apiKeyToken
        Vue.set(state.accounts, index, updatedAccount)
    },
    [RootStateMutations.createAccount] (state: State, account: Account) {
        state.accounts.push(account)
    },
    [RootStateMutations.setCampaign] (state: State, campaign: number) {
        state.currentCampaign = campaign
    },
    [RootStateMutations.setCampaigns] (state: State, campaigns: Array<Campaign>) {
        state.campaigns = campaigns
    },
    [RootStateMutations.updateCampaign] (state: State, campaign: Campaign) {
        const index = state.campaigns.findIndex(value => {
            return value.id === campaign.id
        })
        Vue.set(state.campaigns, index, campaign)
    },
    [RootStateMutations.addCampaign] (state: State, campaign: Campaign) {
        state.campaigns.push(campaign)
    },
    [RootStateMutations.deleteCampaign] (state: State, campaignId: number) {
        state.campaigns = state.campaigns.filter(value => {
            return value.id !== campaignId
        })
    },
    [RootStateMutations.setSettings] (state: State, baseSettings: Settings) {
        state.settings = baseSettings
    },
    [RootStateMutations.setReferences] (state: State, references: References) {
        state.references = references
    },
    [RootStateMutations.setCampaignReferences] (state: State, campaignReferences: CampaignReferences) {
        state.campaignReferences = campaignReferences
    },
    [RootStateMutations.setCampaignReferencesNotLoad] (state: State) {
        state.campaignReferences.loaded = false
    },
    [RootStateMutations.setPriceLink] (state: State, priceLink: string) {
        state.priceLink = priceLink
    },
    [RootStateMutations.setOrderStatuses] (state: State, orderStatuses: OrderStatusesDto) {
        state.orderStatuses = orderStatuses
    },
    [RootStateMutations.setReturnOrderStatuses] (state: State, mapping: ReturnStatusesDto) {
        state.returnOrderStatuses = mapping
    },
    [RootStateMutations.setPaymentTypes] (state: State, mapping: PaymentTypesDto) {
        state.paymentTypes = mapping
    },
    [RootStateMutations.setWarehousesMapping] (state: State, mapping: Array<WarehousesMapping>) {
        state.warehouses = mapping
    },
    [RootStateMutations.setCosts] (state: State, mapping: Array<SettingsMapping>) {
        state.costs = mapping
    },
    [RootStateMutations.setCatalogMapping] (state: State, mapping: CatalogManagementDto) {
        state.catalogMapping = mapping
    },
    [RootStateMutations.setNotificationKey] (state: State, notificationKey: string) {
        state.notificationKey = notificationKey
    }
}
